module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_data03-7d9f7375609a2199b1e14dff8ec86ee0.png";